<template>
  <v-card
    max-width="620"
    class="mx-auto my-10 pb-4"
    :class="review.user_is_blocked ? 'red lighten-5' : ''"
    :style="`background-color: ${review.is_hidden ? '#f0f0f0' : ''};`"
  >
    <v-card-text>
      <div class="d-flex mb-2">
        <v-avatar v-if="review.user_avatar">
          <img :src="review.user_avatar.url" :alt="review.user_full_name" />
        </v-avatar>
        <div class="ml-3">
          <label class="d-block body-2">
            <router-link
              class="text-decoration--none"
              :to="{ name: 'user.details', params: { id: review.user_id } }"
            >
              {{ review.user_full_name }}
            </router-link>
          </label>
          <label class="d-block caption grey--text">
            {{ review.addedDate }}
          </label>
        </div>

        <div style="position: absolute; right: 48px; z-index: 1;">
          <v-btn
            :loading="loading"
            class="error"
            dark
            small
            v-if="!review.user_is_blocked"
            @click="toggleHideReview"
            >{{ review.is_hidden ? 'Unhide' : 'Hide' }} Review</v-btn
          >
        </div>

        <v-spacer></v-spacer>
        <div>
          <v-chip
            small
            dark
            label
            class="ml-2"
            color="red darken-3"
            v-if="review.user_is_blocked"
            >BLOCKED USER</v-chip
          >
        </div>
      </div>

      <div style="position: absolute; right: 64px; z-index: 1;">
        <v-btn
          :loading="loading"
          class="primary mt-10"
          dark
          small
          v-if="!review.user_is_blocked"
          :disabled="review.is_hidden"
          @click="toggleHideComment"
          >{{ review.is_comment_hidden ? 'Unhide' : 'Hide' }} Comment</v-btn
        >
      </div>

      <v-card
        class="pa-4 mt-8 mx-8"
        :style="
          review.is_comment_hidden || review.user_is_blocked || review.is_hidden
            ? 'opacity: 0.4'
            : 'opacity: 1'
        "
      >
        <div>
          <router-link
            class="text-decoration--none"
            :to="{ name: 'trips.update', params: { id: review.trip_id } }"
            >{{ review.trip_name }}</router-link
          >
        </div>

        <div>
          <v-rating
            v-model="review.rating"
            bg-color="black"
            color="yellow darken-3"
            medium
            dense
          ></v-rating>
        </div>
        <div class="body-1 my-3">
          {{ review.review }}
        </div>
      </v-card>

      <div
        class="text-center mt-6 mx-8"
        v-if="review.photos && review.photos.length > 0"
      >
        <review-photos
          :media="review.photos"
          :mediaLoading="loading"
          :isUserBlocked="review.user_is_blocked"
          :isReviewHidden="review.is_hidden"
        />
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex'
import ReviewPhotos from './ReviewPhotos'

export default {
  data() {
    return {
      loading: false,
      snackbar: {
        show: false,
        message: null,
        color: ''
      },
      showPhotos: true
    }
  },

  props: ['review'],

  components: {
    ReviewPhotos
  },

  methods: {
    ...mapActions({
      toggleHideTripReview: 'review/toggleHideTripReview',
      toggleHideReviewComment: 'review/toggleHideReviewComment'
    }),

    toggleHideComment() {
      this.loading = true
      this.toggleHideReviewComment(this.review.user_trip_review_id)
        .then(() => {
          this.loading = false
          this.review.is_comment_hidden = !this.review.is_comment_hidden
          this.showSnackbar(
            `Review comment ${
              this.review.is_comment_hidden ? 'restored' : 'hidden'
            } successfully!`
          )
        })
        .catch(err => {
          this.loading = false
          if (err.response.status === 404) {
            this.showSnackbar(
              'The review you are trying to hide/unhide is no longer existing.',
              'error'
            )
          }
        })
    },

    toggleHideReview() {
      this.loading = true
      this.toggleHideTripReview(this.review.user_trip_review_id)
        .then(() => {
          this.loading = false
          this.review.is_hidden = !this.review.is_hidden
          this.showSnackbar(
            `Trip review ${
              this.review.is_hidden ? 'restored' : 'hidden'
            } successfully!`
          )
        })
        .catch(err => {
          this.loading = false
          if (err.response.status === 404) {
            this.showSnackbar(
              'The review you are trying to hide/unhide is no longer existing.',
              'error'
            )
          }
        })
    },

    showSnackbar(message, color) {
      this.snackbar.message = message
      this.snackbar.show = true
      this.snackbar.color = color
    }
  }
}
</script>
